export default "__VITE_ASSET__C$EmD0sy__"